import React from 'react';
import { BarChart, Compass, BookOpen, Timer } from 'lucide-react';

export default function Features() {
    const featuresData = [
        {
            title: "Progress Tracking",
            description: "Track your learning journey with detailed analytics and milestone achievements.",
            icon: BarChart
        },
        {
            title: "Personalized Paths",
            description: "Customized learning roadmaps tailored to your specific goals and skill level.",
            icon: Compass
        },
        {
            title: "Expert Content",
            description: "Access curated materials and resources vetted by industry professionals.",
            icon: BookOpen
        },
        {
            title: "Time-Efficient",
            description: "Learn at your own pace with optimized schedules that fit your availability.",
            icon: Timer
        }
    ];
    
    return (
        <div className="hero  bg-base-100 py-[10rem] px-4 sm:px-6 lg:px-8 ">
        <div className="container mx-auto max-w-[1200px]">
                <div className="text-center mb-12 sm:mb-20">
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-3 font-poppins">
                        Why Choose PathFinder
                    </h2>
                    <p className="py-4 md:py-6 text-lg md:text-xl lg:text-xl max-w-3xl mx-auto text-base-content/80 font-opensans">
                        Our platform is designed to help you navigate your learning journey efficiently.
                    </p>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 xl:gap-10">
                    {featuresData.map((feature, index) => {
                        const Icon = feature.icon;
                        return (
                            <div
                                key={index}
                                className="card bg-base-200 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 h-full hover:border hover:border-secondary"
                            >
                                <div className="card-body items-center text-center p-6 sm:p-8">
                                    <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary/10 mb-5">
                                        <Icon className="text-secondary w-10 h-10" />
                                    </div>
                                    <h3 className="card-title text-xl md:text-2xl font-bold mb-3 font-poppins">{feature.title}</h3>
                                    <p className="text-base-content/70 text-base md:text-md font-opensans">{feature.description}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}